
import { mapState } from 'vuex';

export default {
  name: 'StockNotification',

  props: {
    sku: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      sent: false,
      loading: false,
      message: null,
      errorMessage: null,
      email: null,
      pressed: false,
      showInput: true,
    };
  },

  computed: {
    ...mapState({
      patientId: (state) => state.patientId,
      user: (state) => state.user,
    }),
  },

  watch: {
    email() {
      this.resetMessage();
    },
  },

  mounted() {
    if (this.user) {
      this.email = this.user.email;
    }
  },

  methods: {
    closeStockNotification() {
      this.$emit('close');
      this.clearForm();
    },

    resetMessage() {
      this.message = null;
      this.errorMessage = null;
    },

    clearForm() {
      this.sent = false;
      this.loading = false;
      this.message = null;
      this.email = null;
      this.pressed = false;
      this.showInput = true;
    },

    hideInput() {
      setTimeout(() => {
        this.showInput = false;
      }, 500);
    },

    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    },

    async submit() {
      this.pressed = true;

      if (!this.sent) {
        if (this.email && this.isValidEmail(this.email)) {
          this.loading = true;

          this.hideInput();
          try {
            await this.$bolev.notifyWhenBackInStock({
              sku: this.sku,
              email: this.email,
              patient_id: this.patientId,
            });
            this.loading = false;
            this.sent = true;
            this.message = this.$t('shop.notifyMessage', {
              email: this.email,
            });
          } catch (_) {
            this.loading = false;
            this.errorMessage = this.$t('forms.invalid');
          }
        } else {
          this.loading = false;
          this.errorMessage = this.email
            ? this.$t('forms.invalidMail')
            : this.$t('forms.empty');
        }
      }
    },
  },
};
